import { CSSProperties } from "react";
import { cn } from "nazare-ui/utils";
import styles from "./styles/skeleton-row.module.css";

export type SkeletonBlockProps = {
  width?: string | number;
  height?: string | number;
  /** Defaults to the shared `--radius-xxs` token; pass `"var(--radius-full)"`
   * for a circular/pill placeholder (e.g. an avatar or a status-pill). */
  radius?: string;
  className?: string;
};

/**
 * Generic shimmering placeholder block — the non-table-row counterpart to
 * `<SkeletonRow>` (see skeleton-row.tsx), for stat numbers, chart areas,
 * ranked-list rows, card headers, anything that isn't a `<tr>`. Compose a
 * few of these to mimic whatever real content shape is loading; there's no
 * single "right" layout since every section's content differs.
 */
export function SkeletonBlock({
  width = "100%",
  height = 14,
  radius,
  className,
}: SkeletonBlockProps) {
  return (
    <div
      className={cn(styles.skeletonBlock, className)}
      aria-hidden="true"
      style={{ width, height, borderRadius: radius } as CSSProperties}
    />
  );
}
